import { call, put, takeLatest } from "redux-saga/effects";

import apis from "services/analytics";

import transactionsSlice from ".";
const { actions } = transactionsSlice;

function* searchWidgetAnalytics(action) {
  try {
    const response = yield call(apis.searchWidgetAnalytics, action.payload);
    yield put(actions.searchWidgetAnalyticsSuccess(response));
  } catch (error) {
    yield put(actions.searchWidgetAnalyticsError());
  }
}

function* getWidgetAnalyticsDetails(action) {
  try {
    const response = yield call(apis.getWidgetAnalyticsDetails, action.payload);
    yield put(actions.getWidgetAnalyticsDetailsSuccess(response));
  } catch (error) {
    yield put(
      actions.getWidgetAnalyticsDetailsError(
        error?.response?.data || "There was an error"
      )
    );
  }
}

function* getWidgetAnalyticsTransactions(action) {
  try {
    const response = yield call(
      apis.getWidgetAnalyticsTransactions,
      action.payload
    );
    yield put(actions.getWidgetAnalyticsTransactionsSuccess(response));
  } catch (error) {
    yield put(
      actions.getTransactionDetailsError(
        error?.response?.data || "There was an error"
      )
    );
  }
}

function* searchWidgetAnalyticsTransactions(action) {
  try {
    const response = yield call(
      apis.searchWidgetAnalyticsTransactions,
      action.payload
    );
    yield put(actions.getWidgetAnalyticsTransactionsSuccess(response));
  } catch (error) {
    yield put(
      actions.getTransactionDetailsError(
        error?.response?.data || "There was an error"
      )
    );
  }
}

function* getWidgetAnalyticsTransactionsGraphData(action) {
  try {
    const response = yield call(
      apis.getWidgetAnalyticsTransactionsGraphData,
      action.payload
    );
    yield put(actions.getWidgetAnalyticsTransactionsGraphDataSuccess(response));
  } catch (error) {
    yield put(
      actions.getWidgetAnalyticsTransactionsGraphDataError(
        error?.response?.data || "There was an error"
      )
    );
  }
}
// function* getTransactionDetails(action) {
//   try {
//     const { data } = yield call(apis.getTransactionDetails, action.payload);
//     yield put(actions.getTransactionDetailsSuccess(data));
//   } catch (error) {
//     yield put(
//       actions.getTransactionDetailsError(
//         error?.response?.data || "There was an error"
//       )
//     );
//   }
// }
export function* analyticsSaga() {
  yield takeLatest(actions.searchWidgetAnalytics.type, searchWidgetAnalytics);
  yield takeLatest(
    actions.getWidgetAnalyticsDetails.type,
    getWidgetAnalyticsDetails
  );
  yield takeLatest(
    actions.getWidgetAnalyticsTransactions.type,
    getWidgetAnalyticsTransactions
  );
  yield takeLatest(
    actions.searchWidgetAnalyticsTransactions.type,
    searchWidgetAnalyticsTransactions
  );
  yield takeLatest(
    actions.getWidgetAnalyticsTransactionsGraphData.type,
    getWidgetAnalyticsTransactionsGraphData
  );
  // yield takeLatest(actions.getTransactionDetails.type, getTransactionDetails);
}
